import { render, staticRenderFns } from "./notifs.vue?vue&type=template&id=693b4c81"
import script from "./notifs.vue?vue&type=script&lang=js"
export * from "./notifs.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports